module.exports = [{
      plugin: require('/Users/james/_WORK/NCSoft/ncsoft-bns-f1-banner/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
